export default __webpack_public_path__ + "static/media/logo.f84c56a6.png";